/**
 * Item IDs are serial numbers: letters, digits, ".", "-" and "_". Anything
 * else is almost always a mistake -- a scanner adding a control character
 * or an unreadable byte (stored as "�"), a pasted comma, or a QR code that
 * isn't a serial. leatherback refuses the same characters on create.
 */
export const ITEM_ID_PATTERN = /^[A-Za-z0-9._-]+$/;

// Never part of a serial: control characters, the replacement character
// "�" a scanner's unreadable byte becomes, and zero-width characters.
// eslint-disable-next-line no-control-regex
const SCANNER_NOISE = /[\u0000-\u001f\u007f-\u009f\ufffd\u200b-\u200d\u2060\ufeff]/g;

/** Removes scanner noise and surrounding spaces; keeps everything else. */
export function cleanItemId(raw: string): string {
  return raw.replace(SCANNER_NOISE, '').trim();
}

/** Why an (already cleaned) item ID can't be used, or null when it can. */
export function itemIdProblem(id: string): string | null {
  if (!id) return 'Enter the item ID.';
  if (!ITEM_ID_PATTERN.test(id)) {
    return `“${id}” can only contain letters, digits, “.”, “-” and “_”.`;
  }
  return null;
}
